var i = /* @__PURE__ */ ((t) => (t.ListItem = "listitem", t.MenuItem = "menuitem", t.Option = "option", t))(i || {});
const m = ["listitem", "option", "menuitem"];
export {
  m as MENU_ITEM_ROLES,
  i as MenuItemRole
};
